export default __webpack_public_path__ + "static/media/watch-1.b90d3298.png";